export default __webpack_public_path__ + "static/media/vt.b76f3a5f.png";